// import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			redirect: '/Sites'
		}, {
			path: '/Login',
			name: 'Login',
			component: resolve => require(['@/components/login/login'], resolve)
		}, {
			path: '/Sites',
			component: resolve => require(['@/components/Sites/List'], resolve),
			name: 'Sites',
			meta: { requireAuth: true }
		}, {
			path: '/Secure',
			component: resolve => require(['@/components/Secure/secure'], resolve),
			name: 'Secure',
			meta: { requireAuth: true }
		}, {
			path: '/User',
			component: resolve => require(['@/components/common/Home'], resolve),
			children: [
				{
					path: 'User/:id',
					component: resolve => require(['@/components/User/secure'], resolve),
					name: 'Secure',
					meta: { requireAuth: true, keepAlive: true },
				}, {
					path: 'webInfo',
					component: resolve => require(['@/components/Website/webInfo'], resolve),
					name: 'webInfo',
					meta: { requireAuth: true }
				}, {
					path: 'webDomain',
					component: resolve => require(['@/components/Website/webDomain'], resolve),
					name: 'webDomain',
					meta: { requireAuth: true }
				}, {
					path: 'webLang',
					component: resolve => require(['@/components/Website/webLang'], resolve),
					name: 'webLang',
					meta: { requireAuth: true }
				}, {
					path: 'Article/:id',
					component: resolve => require(['@/components/AddData/Article/Article'], resolve),
					name: 'Article',
					meta: { requireAuth: true }
				}, {
					path: 'Article/:id/addArticle',
					component: resolve => require(['@/components/AddData/Article/addArticle'], resolve),
					name: 'addArticle',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Article/editArticle/:editId',
					component: resolve => require(['@/components/AddData/Article/editArticle'], resolve),
					name: 'editArticle',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Article/:id/addArticleCats',
					component: resolve => require(['@/components/AddData/Article/addArticleCats'], resolve),
					name: 'addArticleCats',
					meta: { requireAuth: true }
				}, {
					path: 'Article/editArticleCats/:id',
					component: resolve => require(['@/components/AddData/Article/editArticleCats'], resolve),
					name: 'editArticleCats',
					meta: { requireAuth: true }
				}, {
					path: 'Product/:id',
					component: resolve => require(['@/components/AddData/Product/Product'], resolve),
					name: 'Product',
					meta: { requireAuth: true }
				}, {
					path: 'Product/:id/addProduct',
					component: resolve => require(['@/components/AddData/Product/addProduct'], resolve),
					name: 'addProduct',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Product/editProduct/:editId',
					component: resolve => require(['@/components/AddData/Product/editProduct'], resolve),
					name: 'editProduct',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Product/:id/addProductCats',
					component: resolve => require(['@/components/AddData/Product/addProductCats'], resolve),
					name: 'addProductCats',
					meta: { requireAuth: true }
				}, {
					path: 'Product/editProductCats/:id',
					component: resolve => require(['@/components/AddData/Product/editProductCats'], resolve),
					name: 'editProductCats',
					meta: { requireAuth: true }
				}, {
					path: 'Photo/:id',
					component: resolve => require(['@/components/AddData/Photo/Photo'], resolve),
					name: 'Photo',
					meta: { requireAuth: true }
				}, {
					path: 'Photo/:id/addPhoto',
					component: resolve => require(['@/components/AddData/Photo/addPhoto'], resolve),
					name: 'addPhoto',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Photo/editPhoto/:editId',
					component: resolve => require(['@/components/AddData/Photo/editPhoto'], resolve),
					name: 'editPhoto',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Photo/:id/addPhotoCats',
					component: resolve => require(['@/components/AddData/Photo/addPhotoCats'], resolve),
					name: 'addPhotoCats',
					meta: { requireAuth: true }
				}, {
					path: 'Photo/editPhotoCats/:id',
					component: resolve => require(['@/components/AddData/Photo/editPhotoCats'], resolve),
					name: 'editPhotoCats',
					meta: { requireAuth: true }
				}, {
					path: 'Download/:id',
					component: resolve => require(['@/components/AddData/Download/Download'], resolve),
					name: 'Download',
					meta: { requireAuth: true }
				}, {
					path: 'Download/:id/addDownload',
					component: resolve => require(['@/components/AddData/Download/addDownload'], resolve),
					name: 'addDownload',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Download/editDownload/:editId',
					component: resolve => require(['@/components/AddData/Download/editDownload'], resolve),
					name: 'editDownload',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Download/:id/addDownloadCats',
					component: resolve => require(['@/components/AddData/Download/addDownloadCats'], resolve),
					name: 'addDownloadCats',
					meta: { requireAuth: true }
				}, {
					path: 'Download/editDownloadCats/:id',
					component: resolve => require(['@/components/AddData/Download/editDownloadCats'], resolve),
					name: 'editDownloadCats',
					meta: { requireAuth: true }
				}, {
					path: 'Video/:id',
					component: resolve => require(['@/components/AddData/Video/Video'], resolve),
					name: 'Video',
					meta: { requireAuth: true }
				}, {
					path: 'Video/:id/addVideo',
					component: resolve => require(['@/components/AddData/Video/addVideo'], resolve),
					name: 'addVideo',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Video/editVideo/:editId',
					component: resolve => require(['@/components/AddData/Video/editVideo'], resolve),
					name: 'editVideo',
					meta: { requireAuth: true, keepAlive: true, }
				}, {
					path: 'Video/:id/addVideoCats',
					component: resolve => require(['@/components/AddData/Video/addVideoCats'], resolve),
					name: 'addVideoCats',
					meta: { requireAuth: true }
				}, {
					path: 'Video/editVideoCats/:id',
					component: resolve => require(['@/components/AddData/Video/editVideoCats'], resolve),
					name: 'editVideoCats',
					meta: { requireAuth: true }
				}, {
					path: 'Feedback',
					component: resolve => require(['@/components/Feedback/List'], resolve),
					name: 'Feedback',
					meta: { requireAuth: true }
				}, {
					path: 'Template',
					component: resolve => require(['@/components/Template/Template'], resolve),
					name: 'Template',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Lanuage',
					component: resolve => require(['@/components/Template/Lanuage'], resolve),
					name: 'Lanuage',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'MinApp',
					component: resolve => require(['@/components/Template/MinApp'], resolve),
					name: 'MinApp',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'MinApp/:id',
					component: resolve => require(['@/components/Template/MinApp'], resolve),
					name: 'MinApp',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Mpbinding',
					component: resolve => require(['@/components/Mp/Mpbinding'], resolve),
					name: 'Mpbinding',
					meta: { requireAuth: true }
				}, {
					path: 'Mpautoreply',
					component: resolve => require(['@/components/Mp/Mpautoreply'], resolve),
					name: 'Mpautoreply',
					meta: { requireAuth: true }
				}, {
					path: 'Mpfollow',
					component: resolve => require(['@/components/Mp/Reply/Mpfollow'], resolve),
					name: 'Mpfollow',
					meta: { requireAuth: true }
				}, {
					path: 'Mpkeyword',
					component: resolve => require(['@/components/Mp/Reply/Mpkeyword'], resolve),
					name: 'Mpkeyword',
					meta: { requireAuth: true }
				}, {
					path: 'Mp/Reply/Add',
					component: resolve => require(['@/components/Mp/Reply/Add'], resolve),
					name: 'addReply',
					meta: { requireAuth: true }
				}, {
					path: 'Mp/Reply/Edit',
					component: resolve => require(['@/components/Mp/Reply/Edit'], resolve),
					name: 'editReply',
					meta: { requireAuth: true }
				}, {
					path: 'Mpcusmenu',
					component: resolve => require(['@/components/Mp/Mpcusmenu'], resolve),
					name: 'Mpcusmenu',
					meta: { requireAuth: true }
				}, {
					path: 'Mpfans',
					component: resolve => require(['@/components/Mp/Mpfans'], resolve),
					name: 'Mpfans',
					meta: { requireAuth: true }
				}, {
					path: 'Mpnews',
					component: resolve => require(['@/components/Mp/Mpnews'], resolve),
					name: 'Mpnews',
					meta: { requireAuth: true }
				}, {
					path: 'Mpmaterial',
					component: resolve => require(['@/components/Mp/Mpmaterial'], resolve),
					name: 'Mpmaterial',
					meta: { requireAuth: true }
				}, {
					path: 'Mp/Msg/Edit/:editId',
					component: resolve => require(['@/components/Mp/Msg/Edit'], resolve),
					name: 'EditMsg',
					meta: { requireAuth: true }
				}, {
					path: 'Mp/Msg/Add',
					component: resolve => require(['@/components/Mp/Msg/Add'], resolve),
					name: 'AddMsg',
					meta: { requireAuth: true }
				}, {
					path: 'Category',
					component: resolve => require(['@/components/Category/List'], resolve),
					name: 'Category',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Category/Add',
					component: resolve => require(['@/components/Category/Add'], resolve),
					name: 'AddCategory',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Category/Edit/:id',
					component: resolve => require(['@/components/Category/Edit'], resolve),
					name: 'EditCategory',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Single',
					component: resolve => require(['@/components/AddData/Single/List'], resolve),
					name: 'Single',
					meta: { requireAuth: true }
				}, {
					path: 'Single/Add',
					component: resolve => require(['@/components/AddData/Single/Add'], resolve),
					name: 'AddSingle',
					meta: { requireAuth: true }
				}, {
					path: 'Single/Edit/:editId',
					component: resolve => require(['@/components/AddData/Single/Edit'], resolve),
					name: 'EditSingle',
					meta: { requireAuth: true }
				}, {
					path: 'Link',
					component: resolve => require(['@/components/Link/List'], resolve),
					name: 'Link',
					meta: { requireAuth: true }
				}, {
					path: 'Link/Add',
					component: resolve => require(['@/components/Link/Add'], resolve),
					name: 'AddLink',
					meta: { requireAuth: true }
				}, {
					path: 'Link/Edit/:editId',
					component: resolve => require(['@/components/Link/Edit'], resolve),
					name: 'EditLink',
					meta: { requireAuth: true }
				}, {
					path: 'Ad',
					component: resolve => require(['@/components/Ad/List'], resolve),
					name: 'Ad',
					meta: { requireAuth: true }
				}, {
					path: 'Ad/Add',
					component: resolve => require(['@/components/Ad/Add'], resolve),
					name: 'AddAd',
					meta: { requireAuth: true }
				}, {
					path: 'Ad/Edit/:editId',
					component: resolve => require(['@/components/Ad/Edit'], resolve),
					name: 'EditAd',
					meta: { requireAuth: true }
				}, {
					path: 'Module',
					component: resolve => require(['@/components/Module/List'], resolve),
					name: 'Module',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Arcseo',
					component: resolve => require(['@/components/SEO/Arcseo'], resolve),
					name: 'Arcseo',
					meta: { requireAuth: true }
				}, {
					path: 'Catseo',
					component: resolve => require(['@/components/SEO/Catseo'], resolve),
					name: 'Catseo',
					meta: { requireAuth: true }
				}, {
					path: 'Code',
					component: resolve => require(['@/components/Code/List'], resolve),
					name: 'Code',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Code/Edit',
					component: resolve => require(['@/components/Code/Edit'], resolve),
					name: 'EditCode',
					meta: { requireAuth: true, keepAlive: true }
				}, {
					path: 'Index',
					component: resolve => require(['@/components/index/index'], resolve),
					name: 'Index',
					meta: { requireAuth: true, keepAlive: true, title: '首页' },
				}, {
					path: 'Material',
					component: resolve => require(['@/components/Material/material'], resolve),
					name: 'Material',
					meta: { requireAuth: true }
				},
			]
		},
		{
			path: '*',
			redirect: '/Sites'
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js